module.exports = __webpack_public_path__ + "static/img/ind_ban_010.ecbae4f8.jpeg";